export default "__VITE_ASSET__5006310a__"